// import React from 'react'
// import './impact1.css'


// function Impact1() {
//   return (
//     <div className="school-camp-container">
//         <h1>School Eye Chekup Camp</h1>
//         <div>
//             <h2>Program Overview</h2>
//             <p>The School Eye Checkup Camp is a community outreach initiative aimed at providing free eye screenings and vision care services to school children in underserved areas. The program focuses on early detection and treatment of vision problems to ensure that children can learn effectively and lead healthy lives.</p>
//             <h2>Program Objectives</h2>
//             <p>The main objectives of the School Eye Checkup Camp are:</p>
//             <ul>
//                 <li>To conduct comprehensive eye screenings for school children.</li>
//                 <li>To identify and address common vision problems, including refractive errors and eye diseases.</li>
//                 <li>To provide free spectacles and referrals for further treatment when necessary.</li>
//                 <li>To raise awareness about the importance of eye health among students, teachers, and parents.</li>
//                 <li>To collaborate with local schools and communities to ensure maximum participation.</li> 
//             </ul>
//             <h2>Program Activities</h2>
//             <p>The program includes various activities such as:</p>
//             <ul>
//                 <li>Community workshops and seminars on eye health.</li>
//                 <li>Distribution of informational materials, brochures, and posters.</li>
//                 <li>Collaboration with local hospitals and eye banks to facilitate eye care services.</li>
//                 <li>Organizing awareness campaigns in schools, colleges, and community centers.</li>
//                 <li>Engaging with local media to promote eye health stories and testimonials.</li>
//                 <li>Creating social media campaigns to reach a wider audience.</li>
//                 <li>Involving local influencers and community leaders to advocate for eye health.</li>
//                 <li>Conducting eye care drives and registration events.</li>
//             </ul>
//             <h2>Expected Outcomes</h2>
//             <p>The expected outcomes of the School Eye Checkup Camp include:</p>
//             <ul>
//                 <li>Increased awareness about the importance of eye health in the community.</li>
//                 <li>Higher registration rates for eye care services.</li>
//                 <li>Reduction in myths and misconceptions surrounding eye health.</li>
//                 <li>Greater community engagement and participation in eye care initiatives.</li>
//                 <li>Improved collaboration with local organizations and healthcare providers.</li>
//                 <li>Enhanced understanding of the eye care process among the public.</li>
//                 <li>Increased media coverage and positive narratives around eye health.</li>
//                 <li>Strengthened partnerships with local influencers and community leaders.</li>
//                 <li>Successful organization of eye care drives and registration events.</li>
//             </ul>
//             <h2>Conclusion</h2>
//             <p>The School Eye Checkup Camp is a vital initiative aimed at promoting eye health and restoring sight to those in need. By educating the community, dispelling myths, and encouraging individuals to seek eye care services, we can make a significant impact on the lives of those suffering from vision impairment.</p>
//             <p>Through collaborative efforts, community engagement, and awareness campaigns, we can create a culture of eye health and ensure that more individuals have the opportunity to receive the gift of sight.</p>
//             <h2>Call to Action</h2>
//             <p>Join us in spreading awareness about eye health and making a difference in the lives of those in need. Together, we can restore sight and bring hope to countless individuals.</p>
//             <p>For more information about the School Eye Checkup Camp or to get involved, please contact us at [contact information].</p>
//             <p>Thank you for your support in promoting eye health and making a positive impact in our community.</p>
//             <h2>Contact Information</h2>
//             <p>For more information about the School Eye Checkup Camp or to get involved, please contact us at:</p>
//             <p>Phone: +94 11 7 700904</p>

//         </div>
//     </div>
//   )
// }

// export default Impact1


import { Link } from 'react-router-dom';
import React, { useState } from 'react';
import './impact1.css';
import { FaEye, FaChild, FaSchool, FaGlasses, FaUserFriends, FaChartLine, FaImages, FaMapMarkerAlt, FaCalendarAlt, FaPhone } from 'react-icons/fa';
import { IoMdClose } from 'react-icons/io';

function Impact1() {
  const [selectedImage, setSelectedImage] = useState(null);

  const stats = [
    { icon: <FaChild />, number: "10,000+", label: "Children Screened" },
    { icon: <FaGlasses />, number: "2,500+", label: "Spectacles Provided" },
    { icon: <FaSchool />, number: "50+", label: "Schools Visited" },
    { icon: <FaUserFriends />, number: "200+", label: "Teachers Trained" }
  ];

  const galleryImages = [
    { id: 1, src: "https://images.unsplash.com/photo-1588072432836-e10032774350", alt: "Eye screening at school" },
    { id: 2, src: "https://images.unsplash.com/photo-1581595219315-a187dd40c322", alt: "Children receiving glasses" },
    { id: 3, src: "https://images.unsplash.com/photo-1573497491765-dccce02b29df", alt: "Vision testing" },
    { id: 4, src: "https://images.unsplash.com/photo-1579684453423-f84349ef60b0", alt: "Eye health education" }
  ];

  return (
    <div className="school-camp-container">
      {/* Hero Section */}
      <section className="camp-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1><FaEye className="hero-icon" /> School Eye Checkup Camp</h1>
          <p className="hero-tagline"><b>Before entering thr school its  has to be mandotory check the eyes</b></p>
        </div>
      </section>

      {/* Program Overview */}
      <section className="program-overview">
        <div className="overview-content">

          <h2><span className="icon-circle"><FaSchool /></span> Program Overview</h2>
          <p className="overview-text">
            Our School Eye Checkup Camp is a comprehensive community health initiative designed to bring essential vision care services directly to school children in underserved areas. 
            Through this program, we conduct thorough eye examinations, provide free corrective eyewear, and offer referrals for specialized treatment when needed. 
            Our mobile team of optometrists and eye care professionals works closely with school administrations to implement these camps with minimal disruption to academic schedules.
          </p>
          <div className="impact-stats">
            {stats.map((stat, index) => (
              <div className="stat-card" key={index}>
                <div className="stat-icon">{stat.icon}</div>
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
        <div 
        className="overview-image"
        style={{ backgroundImage: "url('/school.png')" }}
      ></div>
      </section>

      {/* Program Objectives */}
      <section className="program-objectives">
        <h2><span className="icon-circle"><FaChartLine /></span> Program Objectives</h2>
        <div className="objectives-grid">
          <div className="objective-card">
            <div className="objective-icon"><FaEye /></div>
            <h3>Comprehensive Screenings</h3>
            <p>Conduct thorough eye examinations for school children to detect vision problems early</p>
          </div>
          <div className="objective-card">
            <div className="objective-icon"><FaGlasses /></div>
            <h3>Vision Correction</h3>
            <p>Provide free spectacles and referrals for specialized treatment when needed</p>
          </div>
          <div className="objective-card">
            <div className="objective-icon"><FaUserFriends /></div>
            <h3>Education & Awareness</h3>
            <p>Teach students, teachers and parents about eye health and vision care</p>
          </div>
          <div className="objective-card">
            <div className="objective-icon"><FaSchool /></div>
            <h3>Community Partnership</h3>
            <p>Collaborate with schools and local organizations for sustainable impact</p>
          </div>
        </div>
      </section>

 

      {/* Program Details */}
      <section className="program-details">
        <div className="details-content">
          <h2>How It Works</h2>
          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>School Selection</h3>
                <p>We partner with education authorities to identify schools in areas with limited access to eye care</p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Pre-Camp Preparation</h3>
                <p>Teachers are trained to conduct preliminary vision tests and identify students needing attention</p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Eye Checkup Day</h3>
                <p>Our team conducts comprehensive screenings and prescribes corrective measures</p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Follow Up</h3>
                <p>We deliver prescribed glasses and refer critical cases to partner hospitals</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="camp-cta">
        <h2>Bring the Eye Checkup Camp to Your School</h2>
        <div className="contact-methods">
          <div className="contact-method">
            <FaPhone className="contact-icon" />
            <p>Call us: +94 11 7 700904</p>
          </div>
          <div className="contact-method">
            <FaMapMarkerAlt className="contact-icon" />
            <p>Visit us: Maradana Road, Colombo 10</p>
          </div>
          <div className="contact-method">
            <FaCalendarAlt className="contact-icon" />
            <p><b>Open Mon-Wed: </b>9:00 AM - 6:00 PM  </p>
            <p><b>Open Fri & Sat: </b> 9:00 AM - 6:00 PM  </p>
            <p><b>Thu & Sun: </b>Closed</p>
          </div>
        </div>
        <Link to="/schoolvisit">
          <button className="cta-button">Request a School Visit</button>
        </Link>

      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div className="image-modal">
          <div className="modal-content">
            <IoMdClose className="close-button" onClick={() => setSelectedImage(null)} />
            <img src={selectedImage} alt="Enlarged view" />
          </div>
        </div>
      )}
    </div>
  );
}

export default Impact1;